import { motion } from "framer-motion";

export const fadeInUp = {
    hidden: { opacity: 0, y: 36 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] },
    },
};

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 0.5, ease: "easeOut" },
    },
};

export const scaleIn = {
    hidden: { opacity: 0, scale: 0.92 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
    },
};

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.12, delayChildren: 0.08 },
    },
};

// amount bajo: en móvil los grids de una columna son muy altos y con un
// umbral grande la animación nunca se disparaba (contenido invisible).
export const viewportOnce = {
    once: true,
    margin: "-40px",
    amount: 0.05,
};

export function MotionSection({ children, className = "", id, ...props }) {
    return (
        <motion.section
            id={id}
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={fadeInUp}
            {...props}
        >
            {children}
        </motion.section>
    );
}

export function MotionDiv({ children, className = "", variants = fadeInUp, delay = 0, ...props }) {
    const mergedVariants =
        delay > 0
            ? {
                  ...variants,
                  visible: {
                      ...variants.visible,
                      transition: {
                          ...(variants.visible?.transition || {}),
                          delay,
                      },
                  },
              }
            : variants;

    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={mergedVariants}
            {...props}
        >
            {children}
        </motion.div>
    );
}

export function StaggerGrid({ children, className = "" }) {
    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={staggerContainer}
        >
            {children}
        </motion.div>
    );
}

export function StaggerItem({ children, className = "" }) {
    return (
        <motion.div className={className} variants={fadeInUp}>
            {children}
        </motion.div>
    );
}
